// Non-translated language names
export enum LanguageNames {
	af = 'Afrikaans',
	am = 'አማርኛ',
	az = 'Azərbaycan',
	bg = 'български',
	bn = 'বাংলা',
	bs = 'Bosanski',
	cnh = 'Chin Hakha',
	cs = 'čeština',
	da = 'Dansk',
	de = 'Deutsch',
	el = 'ελληνικά',
	en = 'English',
	'en-au' = 'English (Australian)',
	'en-gb' = 'English (United Kingdom)',
	es = 'Español',
	'es-419' = 'Español (Latinoamérica)',
	'es-es' = 'Español (España)',
	et = 'Eestlane',
	fi = 'Suomi',
	fr = 'Français',
	'fr-ca' = 'Français (Canada)',
	ha = 'Hausa',
	hi = 'हिंदी',
	hmn = 'Hmong',
	hr = 'Hrvatski',
	ht = 'Kreyòl Ayisyen',
	hu = 'Magyar',
	id = 'Bahasa Indonesia',
	it = 'Italiano',
	ja = '日本語',
	ka = 'ქართველი',
	kar = 'Karen',
	ko = '한국어',
	'ku-kmr' = 'Kurmanji',
	lt = 'Lietuvis',
	lv = 'Latvietis',
	ms = 'Bahasa Melayu',
	my = 'ဗမာ',
	ne = 'नेपाली',
	nl = 'Nederlands',
	no = 'Norsk',
	pl = 'Polski',
	pt = 'Português',
	'pt-br' = 'Português (Brasileiro)',
	ro = 'Română',
	ru = 'Русский',
	sk = 'Slovák',
	sl = 'Slovenščina',
	so = 'Soomaali',
	sq = 'Shqiptare',
	sr = 'Српски',
	sv = 'Svenska',
	sw = 'Kiswahili',
	ta = 'தமிழ்',
	th = 'ไทย',
	tl = 'Filipino (Tagalog)',
	tr = 'Türkçe',
	uk = 'Український',
	vi = 'Tiếng Việt',
	zh = '中文',
	'zh-cmn-hans' = '中文普通话简体',
	'zh-tw' = '中文 (Traditional)'
}
